// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"650":"67f1117e","994":"131c07e8"}[chunkId] + ".css";
};